// @ts-strict-ignore
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@seeqdev/qomponents';
import { AddFormulaParameterModal } from '@/formula/AddFormulaParameterModal.molecule';
import { FormulaEditorParam } from '@/formula/FormulaParametersTable.molecule';
import { HoverTooltip } from '@/core/HoverTooltip.atom';

interface AddParameterBtnAndModalInterface {
  addParameter: (input: FormulaEditorParam, originalParameter: FormulaEditorParam) => void;
  parameters: FormulaEditorParam[];
  tooltip: string;
  testId?: string;
}

export const AddParameterBtnAndModal: React.FunctionComponent<AddParameterBtnAndModalInterface> = ({
  parameters,
  addParameter,
  tooltip,
  testId = 'addVariableBtn',
}) => {
  const [showFunctionParamModal, setShowFunctionParamModal] = useState(false);
  const { t } = useTranslation();
  return (
    <>
      <HoverTooltip text={tooltip}>
        <div>
          <Button
            testId={testId}
            icon="fa-plus"
            size="sm"
            label={t('ASSET_GROUP_EDITOR.ADD_VARIABLE')}
            onClick={() => setShowFunctionParamModal(true)}
          />
        </div>
      </HoverTooltip>
      {showFunctionParamModal && (
        <AddFormulaParameterModal
          parameters={parameters}
          onSave={addParameter}
          onClose={() => setShowFunctionParamModal(false)}
          testId="functionParamModal"
        />
      )}
    </>
  );
};
